module.exports = __webpack_public_path__ + "img/catalog-product-bg.b26c056.webp";